angular.module('iconoglobe')
.constant('DEBUG_MODE', /*DEBUG_MODE*/ false /*DEBUG_MODE*/ )
.constant('VERSION_TAG', /*VERSION_TAG_START*/ new Date().getTime() /*VERSION_TAG_END*/ )
.constant('LOCALES_BROWSER', {
    en_US: "en_US",
    en_GB: "en_US",
    zh_ZH: "zh-TW",
    es_ES: "es",
    ru_RU: "ru",
    fr_FR: "fr",
    de_DE: "de",
    ja_JA: "ja",
    ko_KO: "ko",
    ar_AR: "ar",
    pt_PT: "pt",
    it_IT: "it",
    no_NO: "no",
    hi_HI: "hi",
    pl_PL: "pl",
    nl_NL: "nl",
    fa_FA: "fa",
    sv_SV: "sv",
    vi_VI: "vi",
    tr_TR: "tr",
    sl_SL: "sl",
    sr_SR: "sr",
    bs_BS: "bs",
    mk_MK: "mk",
    hr_HR: "hr",
    sk_SK: "sk",
    cs_CS: "cs",
    da_DA: "da",
    id_ID: "id",
    lt_LT: "lt",
    hu_HU: "hu",
    ro_RO: "ro",
    fi_FI: "fi",
    el_EL: "el",
    bg_BG: "bg",
    uk_UK: "uk",
    he_HE: "he",
    af_AF: "af",
    km_KM: "km"
})